import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import {
  CreativeTemplateEditorQuery,
  CreativeTemplateEditorQueryVariables
} from './__generated__/CreativeTemplateEditorQuery';
import { CREATIVE_TEMPLATE_EDITOR_QUERY } from './creativeTemplateEditor.query';

export const useCreativeTemplateEditorLazyQuery = (variables: CreativeTemplateEditorQueryVariables) => {
  return useLazyQuery<CreativeTemplateEditorQuery>(CREATIVE_TEMPLATE_EDITOR_QUERY, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
